import React, { FC, useEffect, useState } from "react";
import { Tick } from "../../assets/images";
import { HandleNext } from "../../types";
import { useDispatch } from "react-redux";
import { setCancelRental } from "../../redux/slices/rentalSlice";
import { showToast } from "../../utils/showToast";

const Reason: FC<HandleNext> = ({ handleNext }) => {
  const [selectedOption, setSelectedOption] = useState<string>("");
  const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedOption(event.target.value);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setCancelRental({
        reason: selectedOption,
      })
    );
  }, [selectedOption, dispatch]);

  return (
    <div
      className="fixed z-10 inset-0 overflow-y-auto"
      // ref={paymentOptionModal}
    >
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-[90%] mx-auto sm:max-w-[600px]">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="flex flex-col gap-[30px] w-full items-center  justify-center ">
                <img src={Tick} alt="" className=" h-[100px] w-[100px] " />

                <div className="flex flex-col gap-5 w-full">
                  <p className=" text-black font-Jakarta text-[30px] font-bold leading-[87px] text-center ">
                    Reason for ending trip
                  </p>
                  <form className="flex flex-col gap-5 ">
                    <div className="flex cursor-pointer gap-2 items-center">
                      <input
                        type="radio"
                        name="reason"
                        id="anymore"
                        value={"I don't need the vehicle anymore"}
                        onChange={handleOptionChange}
                      />
                      <label htmlFor="anymore">
                        I don't need the vehicle anymore
                      </label>
                    </div>
                    <div className="flex cursor-pointer gap-2 items-center">
                      <input
                        type="radio"
                        name="reason"
                        id="appointment"
                        value={"My appointment got cancelled"}
                        onChange={handleOptionChange}
                      />
                      <label htmlFor="appointment">
                        My appointment got cancelled
                      </label>
                    </div>
                    <div className="flex cursor-pointer gap-2 items-center">
                      <input
                        type="radio"
                        name="reason"
                        id="schedule"
                        value={"My schedule changed"}
                        onChange={handleOptionChange}
                      />
                      <label htmlFor="schedule">My schedule changed</label>
                    </div>
                    <div className="flex cursor-pointer gap-2 items-center">
                      <input
                        type="radio"
                        name="reason"
                        id="others"
                        value={"Others"}
                        onChange={handleOptionChange}
                      />
                      <label htmlFor="others">Others</label>
                    </div>
                    {selectedOption === "Others" && (
                      <textarea
                        placeholder="Please specify other reasons"
                        value={selectedOption}
                        onChange={(e) => setSelectedOption(e.target.value)}
                        className=" text-darkGreen text-base placeholder:text-darkGreen p-4 placeholder:text-base font-Poppins font-medium min-h-40 my-5"
                      />
                    )}
                  </form>
                  <button
                    type="button"
                    onClick={() => {
                      if (!selectedOption)
                        return showToast("Please select a reason", "error");

                      handleNext();
                    }}
                    className=" px-5 py-2 mx-auto w-2/5 bg-midGreen rounded-lg font-Poppins font-semibold text-[38px] text-center text-white"
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reason;
